module.exports = __webpack_public_path__ + "0001-1369.mp4?c42a3fd61435d736358f63e7011f5b15";


//////////////////
// WEBPACK FOOTER
// ./lib/assets/0001-1369.mp4
// module id = 74
// module chunks = 0